import {useState} from 'react';
import type {BuildingProfileModel} from '@myfm/domain';
import {resolveProfileDraftReview,type ProfileField,type ProfileChoice,type ProfileReview} from './building-profile-draft-review';
const labels:Record<ProfileField,
 string>={
 buildingForm:'Building form',
 constructionYear:'Construction year',
 constructionYearBasis:'Construction year basis',
 heightMetres:'Height (metres)',
 heightBasis:'Height basis',
 storeys:'Storeys including ground floor',
 basementStoreys:'Basement storeys',
 jurisdiction:'Jurisdiction',
 localAuthority:'Local authority',
 fireAuthority:'Fire and rescue authority',
 hrbStatus:'Recorded HRB assessment',
 bsrStatus:'BSR registration status',
 bsrNumber:'BSR registration number',
 sourceNote:'Source or reason for this update',
 heatNetwork:'Communal heat network',
 waterResale:'Water resale'
};
const display=(value:unknown)=>value===null||value===undefined?'Unknown':value===''?'Not provided':String(value);
export function ProfileDraftReview({latest,review,onApply,onCancel}:{latest:BuildingProfileModel;review:ProfileReview;onApply:(facts:BuildingProfileModel['facts'])=>void;onCancel:()=>void}){
 const[choices,setChoices]=useState<Partial<Record<ProfileField,ProfileChoice>>>({});
 const resolved=resolveProfileDraftReview(review,choices);
 return <section className="panel" aria-label="Review current building profile"><h2>Review current building profile</h2>
  <p>Your entries are retained. Review the changes saved while you were editing before continuing.</p>
  {review.changedSavedFields.length?<ul>{review.changedSavedFields.map(field=><li key={field}><strong>{labels[field]}:</strong> {display(latest.facts[field])}</li>)}</ul>
   :<p>Linked building information changed. Review the refreshed applicability screening before saving.</p>}
  {review.conflicts.map(conflict=><fieldset key={conflict.field}><legend>{labels[conflict.field]} changed in both versions</legend>
   <label><input type="radio" name={'profile-choice-'+conflict.field} checked={choices[conflict.field]==='draft'} onChange={()=>setChoices(c=>({...c,[conflict.field]:'draft'}))}/>My entry: {display(conflict.draft)}</label>
   <label><input type="radio" name={'profile-choice-'+conflict.field} checked={choices[conflict.field]==='saved'} onChange={()=>setChoices(c=>({...c,[conflict.field]:'saved'}))}/>Latest saved: {display(conflict.saved)}</label>
  </fieldset>)}
  <p>This review does not save changes or confirm the HRB assessment.</p>
  <button type="button" disabled={!resolved} onClick={()=>resolved&&onApply(resolved)}>Use reviewed values and continue editing</button>
  <button type="button" className="secondary" onClick={onCancel}>Back to my draft</button>
 </section>;
}
